import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@features/auth';
import { useAuth } from '@features/auth';
import authRoutes from './routes/authRoutes';
import hotelRoutes from './routes/hotelRoutes';
import dealRoutes from './routes/dealRoutes';
import miscRoutes from './routes/miscRoutes';

const AppRoutes: React.FC = () => {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      {/* Public Routes */}
      {authRoutes.filter(route => route.props.path === '/login' || route.props.path === '/signup')}

      {/* Landing page - redirect to dashboard if authenticated */}
      <Route
        path="/"
        element={
          isAuthenticated ? (
            <Navigate to="/dashboard" replace />
          ) : (
            miscRoutes.find(route => route.props.path === '/')?.props.element
          )
        }
      />

      {/* Debug route - only in development */}
      {(process.env as any).NODE_ENV === 'development' &&
        authRoutes.find(route => route.props.path === '/auth-debug')}

      {/* Protected Routes */}
      <Route element={<ProtectedRoute />}>
        {/* Hotel Routes */}
        {hotelRoutes}

        {/* Deal Routes */}
        {dealRoutes}

        {/* Misc Routes (except landing and catch-all) */}
        {miscRoutes.filter(route =>
          route.props.path !== '/' &&
          route.props.path !== '*'
        )}
      </Route>

      {/* Catch-all route */}
      {miscRoutes.find(route => route.props.path === '*')}
    </Routes>
  );
};

export default AppRoutes;
